import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { RequestService } from '@df/api/request/request.service';
import { Status } from '@df/core/status';
import { getElementHeight } from '@df/dom/fn/get-element-height';
import { IScrollToOptions } from '@df/dom/scroll/scroll-to.service';
import { GiftcardsAddToBasketComponentDef } from '@df/module-giftcards/giftcards-add-to-basket.component.def';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { ActionComponent } from '../../ui/api/action.component';
import { ResultComponent } from '../../ui/resut/result.component';
import { EGtmAddToCartVia, LocalGtmService } from '../gtm/gtm.service.decorator';

@Component({
    selector: 'giftcards-add-to-basket',
    templateUrl: './giftcards-add-to-basket.html',
    standalone: true,
    imports: [ActionComponent, ResultComponent, TranslationModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GiftcardsAddToBasketComponent extends GiftcardsAddToBasketComponentDef {
    @Input()
    isDisabled?: boolean;
    protected uploadStatus = new Status();
    private gtmService = inject(LocalGtmService);
    protected requestService = inject(RequestService);
    protected override getScrollToErrorOptions(): IScrollToOptions | undefined {
        const headerHeight = getElementHeight('#header');
        return {
            offset: headerHeight ? headerHeight + 20 : undefined
        };
    }
    protected override onSuccess(result?: any) {
        this.gtmService.gtmAddToCartBeEvent(result, EGtmAddToCartVia.pdp);
        return super.onSuccess();
    }
    override _submit(): void {
        if (this.request.file) {
            // manual to avoid remove busy after first request
            this.status.busy = true;
            this.requestService.send(
                undefined,
                {
                    path: 'giftcard/upload',
                    data: { base64_file_data: this.request.file, file_name: 'giftcard-image-' + Date.now().toString() + '.jpg' }
                },
                result => {
                    if (result.result === false) {
                        this.status.error = { error: result.message };
                        this.status.busy = false;
                        this.detectChanges();
                        return;
                    }
                    this.request.am_giftcard_image = result.am_giftcard_image;
                    delete this.request.file;
                    super._submit();
                },
                undefined,
                { fileUpload: true }
            );
        } else {
            this.request.am_giftcard_image = undefined;
            super._submit();
        }
    }
}
